import { render, staticRenderFns } from "./Schematic.vue?vue&type=template&id=64068d8c&"
import script from "./Schematic.vue?vue&type=script&lang=js&"
export * from "./Schematic.vue?vue&type=script&lang=js&"
import style0 from "./Schematic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
installComponents(component, {VAvatar})
